import { createSlice } from '@reduxjs/toolkit'

const loginSlice = createSlice({
    name: 'login',
    initialState: { error: null, loading: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        login() {},
        checkLogin() {},
        loginUsingGoogle() {},
        loginUsingFacebook() {},
        loginUsingApple() {},
        loginSocialsError(state, payload) {
            return state
        },
    },
})

const { actions, reducer } = loginSlice

export const {
    setLoading,
    setError,
    login,
    checkLogin,
    loginUsingFacebook,
    loginUsingGoogle,
    loginUsingApple,
    loginSocialsError,
} = actions

export default reducer
